module.exports = __webpack_public_path__ + "img/login_backimg.92bad376.png";